import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Spinner from './Svgs/Spinner';
import InfoIcon from './Svgs/InfoIcon';
import ShopNext from './Svgs/ShopNext';
import ShopPrev from './Svgs/ShopPrev';

import LengthShort from './Svgs/LengthShort';
import LengthChin from './Svgs/LengthChin';
import LengthShoulder from './Svgs/LengthShoulder';
import LengthLong from './Svgs/LengthLong';

import TypeStraight from './Svgs/TypeStraight';
import TypeWavy from './Svgs/TypeWavy';
import TypeCurly from './Svgs/TypeCurly';
import TypeCoily from './Svgs/TypeCoily';

import DensityNotVery from './Svgs/DensityNotVery';
import DensityMedium from './Svgs/DensityMedium';
import DensityVery from './Svgs/DensityVery';
import DensityNotSure from './Svgs/DensityNotSure';

import ThicknessFine from './Svgs/ThicknessFine';
import ThicknessMedium from './Svgs/ThicknessMedium';
import ThicknessThick from './Svgs/ThicknessThick';
import ThicknessNotSure from './Svgs/ThicknessNotSure';

import BeyondBlue from './Svgs/BeyondBlue';
import CleanUpAustralia from './Svgs/CleanUpAustralia';
import Wires from './Svgs/Wires';

import Resistance from './Svgs/Resistance';
import Cardio from './Svgs/Cardio';
import FlexibilityBalance from './Svgs/FlexibilityBalance';
import Sports from './Svgs/Sports';

import NoFlavour from './Svgs/NoFlavour';


const Svg = ({ name, spin }) => {
  const svgs = {
    spinner: Spinner,
    'info-icon': InfoIcon,
    'shop-next': ShopNext,
    'shop-prev': ShopPrev,
    'length-short': LengthShort,
    'length-chin': LengthChin,
    'length-shoulder': LengthShoulder,
    'length-long': LengthLong,
    'texture-straight': TypeStraight,
    'texture-wavy': TypeWavy,
    'texture-curly': TypeCurly,
    'texture-coily': TypeCoily,
    'density-not-very': DensityNotVery,
    'density-medium': DensityMedium,
    'density-very': DensityVery,
    'density-not-sure': DensityNotSure,
    'thickness-thin': ThicknessFine,
    'thickness-medium': ThicknessMedium,
    'thickness-thick': ThicknessThick,
    'thickness-not-sure': ThicknessNotSure,
    'beyond-blue': BeyondBlue,
    'clean-up-australia': CleanUpAustralia,
    'wires': Wires,
    'resistance': Resistance,
    'cardio': Cardio,
    'flexibility-balance': FlexibilityBalance,
    'sports': Sports,
    'no-flavour': NoFlavour,
  };

  const SvgComponent = svgs[name || 'length-short'];

  if (!SvgComponent) {
    return null;
  }

  return (
    <div className={`d-block ${spin ? 'spin' : ''}`}>
      <SvgComponent />
    </div>
  );
};

Svg.propTypes = {
  name: PropTypes.string,
  spin: PropTypes.bool,
};

Svg.defaultProps = {
  name: 'length-short',
  spin: false,
};

export default memo(Svg);
